<template>
  <div class="animated fadeIn">
    <h3 class="header-title">Learning EPay</h3>
    <label>Let’s see your tuition EPay.</label>
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Explore more on your ePay !</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <!-- <CRow>
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </CRow> -->
    <template>
      <CCard class="mt-4">
        <br />
        <CRow>
          <CCol sm="1"> </CCol>
          <CCol sm="2" class="d-flex justify-content-end">
            <CButton
              @click="collapse = !collapse"
              class="custom-btn-blues"
              text="Filter"
            >
              <i class="fa fa-filter">Filter</i>
            </CButton>
          </CCol>
          <CCol sm="9">  
            <div class="d-flex justify-content-end">
              <vue-json-to-csv
                    :json-data="FilterTransactions"
                    :labels="{
                      TransactionDate: {
                        title: 'TransactionDate',
                      },
                      Date: { title: 'CreatedDate' },
                      ModifiedTime: {
                        title: 'ModifiedDate',
                      },
                      Name: { title: 'Name' },
                      Description: { title: 'Description' },
                      Credit : { title: 'Credit' },
                      Debit : { title: 'Debit' },
                      Status : { title: 'Status' },
                    }"
                    @success="(val) => DownloadSuccess()"
                    @error="(val) => DownloadFail(val)"
                  >
                    <CButton color="info" class="mr-2 float-right custom-btn-blues"
                      >Download Report</CButton
                    >
                  </vue-json-to-csv>
            </div> </CCol>
        </CRow>
        <br />
        <CCollapse :show="collapse" :duration="400">
          <br />
          <CRow>
            <CCol sm="1"> </CCol>
            <CCol sm="1" class="d-flex justify-content-end">
              <div class="custom-text-overview">Filter by</div>
            </CCol>
            <CCol sm="3">
              <v-select
                v-model="selectedName"
                :options="nameOptions"
                @input="FilteredData()"
                columnFilter
              ></v-select>
            </CCol>
            <CCol sm="3">
              <v-select
                v-model="selectedDesc"
                :options="descOptions"
                @input="FilteredData()"
                columnFilter
              ></v-select>
            </CCol>
            <CCol sm="2">
              <v-select
                v-model="selectedStatus"
                :options="statusOptions"
                @input="FilteredData()"
                columnFilter
              ></v-select>
            </CCol>
            <CCol sm="2"> </CCol>
          </CRow>
          <br />
          <CRow>
            <CCol sm="2"> </CCol>
            <CCol sm="2">
              <span>Total Credit: </span>
              <span>
                {{ TotalCredit }}
              </span>
            </CCol>
            <CCol sm="2">
              <span>Total Debit: </span>
              <span>
                {{ TotalDebit }}
              </span>
            </CCol>
            <CCol sm="2">
              <span>Remaining: </span>
              <span>
                {{ TotalRemaining }}
              </span>
            </CCol>
            <CCol sm="2">
              <div form class="checkbox-form">
                <div class="answers">
                  <label class="item">
                    <input
                      type="checkbox"
                      @click="checkAll()"
                      v-model="selectedStatus"
                    />
                    Valid
                    <span class="checkmark" />
                  </label>
                </div>
              </div>
            </CCol>
            <CCol sm="2"> </CCol>
          </CRow>
          <br />
        </CCollapse>

      
      </CCard>
      <template>
        <div>
          <CCard>
            <CRow class="m-0">
              <CCol sm="12" class="table-container">
                <CDataTable
                  :hover="hover"
                  :striped="striped"
                  :bordered="bordered"
                  :small="small"
                  :fixed="fixed"
                  :items="FilterTransactions"
                  :fields="fields"
                  items-per-page-select
                  :items-per-page="small ? 5 : 10"
                  :dark="dark"
                  sorter
                  pagination
                >
                  <template #TransactionDate="{ item }">
                    <td>
                      <CBadge color="success" class="ml-auto">{{
                        item.TransactionDate | moment("DD MMM YYYY HH:mm")
                      }}</CBadge>
                    </td>
                  </template>
                  <template #CreatedDate="{ item }">
                    <td>
                      <CBadge color="success" class="ml-auto">{{
                        item.Date | moment("DD MMM YYYY")
                      }}</CBadge>
                    </td>
                  </template>
                  <template #ModifiedDate="{ item }">
                    <td>
                      <CBadge color="success" class="ml-auto">{{
                        item.ModifiedTime | moment("DD MMM YYYY")
                      }}</CBadge>
                    </td>
                  </template>
                  <template #ParentInfo="{ item }">
                    <td>
                      <h6 style="color: #1e109c" class="text-uppercase">
                        Id : {{ item.UserId }}
                      </h6>
                      <div>
                        <span class="custom-small text-muted"> Parent Name :</span> <span class="custom-small-overview custom-text-overview">{{ item.Name }}</span>
                      </div>
                      <div>
                        <span class="custom-small text-muted"> Description :</span> <span class="custom-small-overview custom-text-overview">{{ item.Description }}</span>
                      </div>
                    </td>
                  </template>
                  <template #TransactionInfo="{ item }">
                    <td>
                      <div>
                        <span class="custom-small text-muted"> Credit :</span> <span class="custom-small-overview custom-text-overview">{{ item.Credit }}</span>
                      </div>
                      <div>
                        <span class="custom-small text-muted"> Debit :</span> <span class="custom-small-overview custom-text-overview">{{ item.Debit }}</span>
                      </div>
                    </td>
                  </template>
                  <!-- <template #DateInfo="{ item }">
                    <td>
                      <div>
                        <span class="custom-small text-muted"> Created Date :</span> <span class="custom-small-overview custom-text-overview">{{  item.CreatedDate | moment("DD MMM YYYY") }}</span>
                      </div>
                      <div>
                        <span class="custom-small text-muted"> Created By :</span> <span class="custom-small-overview custom-text-overview">{{ item.CreatedBy }}</span>
                      </div>
                      <div>
                        <span class="custom-small text-muted"> Modified Date :</span> <span class="custom-small-overview custom-text-overview">{{  item.ModifiedTime | moment("DD MMM YYYY") }}</span>
                      </div>
                    </td>
                  </template> -->
                </CDataTable>
              </CCol>
            </CRow>
            <CRow> </CRow>
          </CCard>
        </div>
      </template>
    </template>
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
Vue.use(VuejsDialog);

import VueJsonToCsv from "vue-json-to-csv";
import VuePapaParse from "vue-papa-parse";
Vue.use(VuePapaParse);

export default {
  name: "EPayTransaction",
  components: {
    cSwitch,
    PulseLoader,
    VueJsonToCsv,
  },
  data: function () {
    return {
      collapse: false,
      Transactions: [],
      selectedStatus: true,
      statusOptions: [],
      selectedName: "SELECT PARENTS NAME-PHONE",
      nameOptions: [],
      selectedPhone: "SELECT PHONE NUMBER PARENTS",
      phoneOptions: [],
      selectedDesc: "SELECT DESCRIPTION",
      descOptions: [],
      selectedDebit: "SELECT DEBIT",
      debitOptions: [],
      selectedCredit: "SELECT CREDIT",
      creditOptions: [],
      isChecked: true,
      fields: [
        { key: "ParentInfo" },
        { key: "TransactionDate" },
        { key: "TransactionInfo" },
        //{ key: "DateInfo" },
        { key: "CreatedDate" },
        { key: "ModifiedDate" },
        { key: "CreatedBy" },
        { key: "Status" },
      ],
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      await this.GetAllTransaction();
      this.FilterTransaction();
    }
    else {
      this.GoToLogin();
    }
  },
  computed: {
    // TotalDebit() {
    //   return this.Transactions.reduce((totalDebit, item) => {
    //     return totalDebit + item.Debit;
    //   }, 0);
    // },
    // TotalCredit() {
    //   return this.Transactions.reduce((totalCredit, item) => {
    //     return totalCredit + item.Credit;
    //   }, 0);
    // },
    // TotalCredit: {
    //   get: function () {
    //     return _.reduce(
    //       this.FilterTransaction,
    //       function (memo, item) {
    //         return memo + item.Credit;
    //       },
    //       0
    //     );
    //   },
    // },
    // TotalDebit: {
    //   get: function () {
    //     return _.reduce(
    //       this.FilterTransaction,
    //       function (memo, item) {
    //         return memo + item.Debit;
    //       },
    //       0
    //     );
    //   },
    // },
  },
  methods: {
    async GetAllTransaction() {
      return this.$API
       .get(this.$AllTransaction, {
          withCredentials: true,
        })
        .then(
          function (response) {
            this.Transactions = response.data;
            this.Transactions = _.orderBy(
              this.Transactions,
              ["TransactionDate"],
              ["desc"]
            );

            this.FilterTransactions = this.Transactions;

            var parentsName = _.uniq(_.map(response.data, "Name"));
            parentsName.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });

            this.nameOptions = parentsName;
            this.nameOptions.unshift("SELECT PARENTS NAME-PHONE");

            var phoneNo = _.uniq(_.map(response.data, "Phone"));
            phoneNo.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.phoneOptions = phoneNo;
            this.phoneOptions.unshift("SELECT PHONE NUMBER PARENTS");
            //this.getPic(this.Transactions.filePath);

            var status = _.uniq(_.map(response.data, "Status"));
            this.statusOptions = status;
            this.statusOptions.unshift("SELECT STATUS");

            var desc = _.uniq(_.map(response.data, "Description"));
            this.descOptions = desc;
            this.descOptions.unshift("SELECT DESCRIPTION");

            var debit = _.uniq(_.map(response.data, "Debit"));
            this.debitOptions = debit;
            this.debitOptions.unshift("SELECT DEBIT");

            var credit = _.uniq(_.map(response.data, "Credit"));
            this.creditOptions = credit;
            this.creditOptions.unshift("SELECT CREDIT");
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    FilterTransaction() {
      console.log("masuk status");

      this.FilterTransactions = this.Transactions;

      if (this.selectedStatus !== "ALL status")
        this.FilterTransactions = _.filter(
          this.FilterTransactions,
          (item) => item.Status === this.selectedStatus
        );
    },
    FilterTransactionName() {
      console.log("masuk nama");

      this.FilterTransactions = this.Transactions;

      if (this.selectedName !== "ALL name")
        this.FilterTransactions = _.filter(
          this.FilterTransactions,
          (item) => item.Name === this.selectedName
        );
    },
    FilterTransactionPhone() {
      console.log("masuk tepon");

      this.FilterTransactions = this.Transactions;

      if (this.selectedPhone !== "ALL phone")
        this.FilterTransactions = _.filter(
          this.FilterTransactions,
          (item) => item.Phone === this.selectedPhone
        );
    },
    FilterTransactionDesc() {
      console.log("masuk desc");

      this.FilterTransactions = this.Transactions;

      if (this.selectedDesc !== "ALL desc")
        this.FilterTransactions = _.filter(
          this.FilterTransactions,
          (item) => item.Description === this.selectedDesc
        );
    },
    FilteredData() {
      console.log("masuk");
      this.FilterTransactions = this.Transactions;

      if (this.selectedName !== "SELECT PARENTS NAME-PHONE")
        this.FilterTransactions = _.filter(
          this.FilterTransactions,
          (item) => item.Name === this.selectedName
        );
      if (this.selectedPhone !== "SELECT PHONE NUMBER PARENTS")
        this.FilterTransactions = _.filter(
          this.FilterTransactions,
          (item) => item.Phone === this.selectedPhone
        );
      if (this.selectedStatus !== "SELECT STATUS")
        this.FilterTransactions = _.filter(
          this.FilterTransactions,
          (item) => item.Status === this.selectedStatus
        );
      if (this.selectedDesc !== "SELECT DESCRIPTION")
        this.FilterTransactions = _.filter(
          this.FilterTransactions,
          (item) => item.Description === this.selectedDesc
        );
      if (this.selectedDebit !== "SELECT DEBIT")
        this.FilterTransactions = _.filter(
          this.FilterTransactions,
          (item) => item.Debit === this.selectedDebit
        );
      if (this.selectedCredit !== "SELECT CREDIT")
        this.FilterTransactions = _.filter(
          this.FilterTransactions,
          (item) => item.Credit === this.selectedCredit
        );

      var totalCredit = _.reduce(
              this.FilterTransactions,
              function (memo, item) {
                return memo + item.Credit;
              },
              0
            );
            this.TotalCredit = totalCredit;
      var totalDebit = _.reduce(
              this.FilterTransactions,
              function (memo, item) {
                return memo + item.Debit;
              },
              0
            );
            this.TotalDebit = totalDebit;
      var totalRemaining = _.reduce(
              this.FilterTransactions,
              function (memo, item) {
                return memo + item.Credit - item.Debit;
              },
              0
            );
            this.TotalRemaining = totalRemaining;
    },
    checkAll() {
      this.isCheck = !this.isCheck;
      this.Status = [];
      if (this.isCheck == true) {
        // Check all
        for (let i in this.Academics) {
          let acad = this.Academics[i];
          if (acad.isAccepted == undefined) {
            acad.isAccepted = true;
          } else if (acad.isAccepted == false) {
            acad.isAccepted = true;
          }
        }
      }
    },
  },
};
</script>

<style>
.checkbox-form {
  display: flex;
  flex-direction: column;
  align-items: self-start;
  font-size: 16px;
}
.custom-text-overview {
    color: #000000 !important; 
}
.custom-small-overview {
    font-size: 90%;
    font-weight: 500;
} 
.custom-small {
    font-size: 90%;
    font-weight: 500;
}
.custom-btn-blues{
  background: #009efb;
  border: 1px solid #009efb;
  color: #ffffff;
  border-radius: 4px;
  width: 155px;
}
</style>